<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';
import { APP_NAME } from '@glow/shared/lib/constants';
import FeaturedMasterPreview from '../FeaturedMasterPreview.vue';
import { graphql } from '@/gql';
import { useQuery } from '@urql/vue';
import { useRoutes } from '@glow/shared/lib/routes';

const { getUrl } = useRoutes();
const { data: masterData } = await useQuery({
  query: graphql(/* GraphQL */ `
    query RecommendBlock_FeaturedMastersQuery {
      featuredMasters {
        id
        ...FeaturedMasterPreview_MasterFragment
      }
    }
  `),
});
</script>

<template>
  <div id="recommended" class="container-md recommend">
    <LandingTitleLayout>
      <template #title>{{ APP_NAME }} рекомендует</template>
    </LandingTitleLayout>

    <div class="recommend__content">
      <div class="recommend__grid">
        <FeaturedMasterPreview
          v-for="master in masterData?.featuredMasters"
          :key="master.id"
          :master="master"
        />
      </div>

      <div class="d-flex justify-content-center">
        <AppButton
          variant="secondary"
          color="primary"
          :to="getUrl('partnerCatalog', { type: 'master' })"
        >
          Перейти к каталогу мастеров
        </AppButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container-md {
  @include media-breakpoint-down(md) {
    padding-left: 0;
    padding-right: 0;
  }
}

.recommend {
  --space: #{stretch-size(375, 1920, 32, 50) stretch-size(375, 1920, 16, 45)};

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--space);
    padding: var(--space);
    background: var(--app-gradient-primary);
    border-radius: 24px;

    @include media-breakpoint-down(md) {
      border-radius: 16px;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--space);

    @include media-breakpoint-up(sm) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include media-breakpoint-up(xl) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
